
		import async from 'preact-cli/async-component';

		function load(cb) {
			require.ensure([], function(require) {
				cb(require("!!../../../node_modules/babel-loader/lib/index.js??ref--0!./index.js"));
			}, "route-hero");
		}

		export default async(load);
	


//////////////////
// WEBPACK FOOTER
// ./routes/hero/index.js
// module id = null
// module chunks = 